<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Search from "@/components/c-select-search";
import { customerService } from "../../../services/contactservice/customer.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Block",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Area,
    Search
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      breadCrumb: {},
      selectCustomer: null,
      propertyData: null,
      customerData: {},
      dataCustomer: 0,
      dataCode: '',
      dataNotation: '',
      dataExpired: this.$moment().format('YYYY-MM-DD'),
    };
      
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingCustomerData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 

  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }

          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;

          this.dataCustomer = this.propertyData.data.temp_customer_id;

          this.dataCode = this.propertyData.data.code;
          this.dataNotation = this.propertyData.data.temp_note;
          this.dataExpired = this.propertyData.data.temp_expired;
          
        });
    },

    loadingCustomerData: function() {
      customerService.getList()
        .then(response => {
          
          this.customerData = response;
        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },

    submitSave: function() {

      if(!this.dataCustomer && this.dataCustomer == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('customer.text') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      }

      
      this.tryingToSubmit = true;

      let obj = {
        temp_customer_id: this.dataCustomer,
        temp_expired: this.dataExpired,
        temp_note: this.dataNotation,
        temp_type: 1
      };

      
      // console.log(JSON.stringify(customer));
      propertyService.update(this.$route.params.id, obj)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "property-list"
          });

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });

        }
      });

      
    },

    clearForm: function() {
      this.dataCode = '';
      this.dataCustomer = 0;
      this.dataNotation = '';
      this.dataExpired = '';
    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, {
        text: $t('property.new'),
        active: true
      }]" :title="this.isAdd ? $t('property.block') + ' ' + $t('property.text') : $t('property.block') + ' ' + $t('property.text')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, this.breadCrumb]" :title="this.isAdd ? $t('property.block') + ' ' + $t('property.text') : $t('property.block') + ' ' + $t('property.text')" />
    </div>
    <Loader :loading="fetchingStats">
    <div class="row">
      <b-form class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="dataCode"
                    :label="'property.text'" 
                    :require="true"
                  /> 
                </div>
                <div class="col-md-4">
                  <Search 
                    :id="'temp_customer_id'"
                    :text="'name'"
                    :text2="'name_en'"
                    v-model="dataCustomer"
                    :list="this.customerData"
                    :require="true"
                    :label="'customer.text'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'datetime-local'"
                    :id="'temp_expired'"
                    v-model="dataExpired"
                    :label="'property.block_till'" 
                    :require="true"
                  /> 
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="7"
                    :id="'temp_note'"
                    v-model="dataNotation"
                    :label="'property.notation'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">

                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
     
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </b-form>
    </div>    
    </Loader>
  </Layout>
</template>